import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BsPencilFill, BsTrashFill } from 'react-icons/bs';
import Header from '../../components/Header';
import FinHeader from '../../Finance/Fheader';

import axios, { encryptData } from '../../Axiosinstance';
import 'bootstrap/dist/css/bootstrap.min.css';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import TextField from '@mui/material/TextField';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import NewBatches from '../../components/Newbatches';
import { toast, ToastContainer } from 'react-toastify';
import Loader from '../../Loader';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { useLocation } from 'react-router-dom';
import { useRef } from 'react';
import Typography from '@mui/material/Typography';
import * as XLSX from "xlsx";
import { Button, Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { buttonBackgroundColor } from '../../common';

const Batches = () => {
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('');
  const [batches, setBatches] = useState([]);
  // const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [totalBatches, setTotalBatches] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Default number of items per page
  const [currentPage, setCurrentPage] = useState(0);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const initialFilterType = searchParams.get('courseType') || ''; // Fallback to empty string
  const [filterType, setFilterType] = useState(initialFilterType);


  const [page, setPage] = useState(0);
  const scrollableDivRef = useRef(null);
  const [hasMore, setHasMore] = useState(true);
  const [totalPage, setTotalPage] = useState('');



  useEffect(() => {
    setPage(0);
    setBatches([]);
    fetchData(search, filterType);
  }, [filterType, search]);

  // const fetchData = async (searchTerm = search, typeFilter = filterType) => {
  //   try {
  //     setLoading(true);
  //     const response = await axios.get('batches/search', {
  //       params: {
  //         size: itemsPerPage,
  //         page: currentPage,
  //         batchcode: searchTerm, // Pass search term as a parameter
  //         type: typeFilter,      // Pass filterType directly
  //       },
  //     });
  //     setBatches(response.data.content);
  //     setTotalBatches(response.data.totalElements);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error('Error fetching batches:', error);
  //     setLoading(false);
  //   }
  // };
  const fetchData = async (searchTerm = search, typeFilter = filterType) => {
    // if (loading || !hasMore) return;
    try {
      const response = await axios.get('batches/search', {
        params: {
          size: itemsPerPage,
          page,
          batchcode: searchTerm,
          type: typeFilter,
        },
      });

      const { content, totalPages } = response.data;

      if (content.length > 0) {
        setBatches((prevData) => (page === 0 ? content : [...prevData, ...content]));
      }

      setTotalPage(totalPages);
      setHasMore(page + 1 < totalPages);
    } catch (error) {
      console.error('Error fetching batches:', error);
      toast.error('Failed to fetch data');
    } finally {
      setLoading(false);
    }
  };

  const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), delay);
    };
  };

  const handleScroll = debounce((event) => {
    const container = event.target; // The scrollable container
    const bottom = container.scrollHeight - container.scrollTop === container.clientHeight;

    if (bottom && !loading && hasMore) {
      setPage((prevPage) => prevPage + 1); // Fetch the next page
    }
  }, 200);


  useEffect(() => {
    const scrollableDiv = scrollableDivRef.current;

    if (scrollableDiv) {
      // Save the current scroll position
      const currentScrollTop = scrollableDiv.scrollTop;

      fetchData(search, filterType).finally(() => {
        // Restore the scroll position after fetching data
        scrollableDiv.scrollTop = currentScrollTop;
      });
    }
  }, [page, filterType]);


  useEffect(() => {
    const scrollableDiv = scrollableDivRef.current;

    if (scrollableDiv) {
      scrollableDiv.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (scrollableDiv) {
        scrollableDiv.removeEventListener('scroll', handleScroll);
      }
    };
  }, [loading, hasMore]);



  useEffect(() => {

    fetchData();

  }, [page]);



  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleSearchClick = () => {
    // Check if search term is not null or empty before fetching data
    setPage(0);
    if (search.trim() !== '') {
      fetchData();
      setBatches([]); // Clear existing data
      fetchData(search, filterType);
      // setSearch('');
    } else {
      toast.error('Please enter a search term');
    }
  };


  const handleResetClick = () => {
    // setCurrentPage(0);
    setSearch('');
    setPage(0);
    // console.log("hi"+search)
  };

  useEffect(() => {
    if (search === '') {
      setPage(0);
      fetchData();
    }
  }, [search]);



  const handleDelete = async (id) => {
    try {
      // Fetch all manages
      const managesResponse = await axios.get('manages');
      const managesData = managesResponse.data;

      // Filter the manages data to check if any manage is associated with the batch
      const associatedManages = managesData.filter(manage => manage.batch_id === id);

      if (associatedManages.length > 0) {
        // If manages are associated with the batch, show a warning
        alert(`This batch is associated with ${associatedManages.length} students(s). Please delete the associated students before deleting this batch.`);
        return;

      } else {
        // If no manages are associated, ask for confirmation
        const confirmDelete = window.confirm('Are you sure you want to delete this course?');

        if (!confirmDelete) {
          return; // Cancel deletion if the user doesn't confirm
        }
      }

      // If user confirms deletion or there are no associated manages, proceed with deletion
      await axios.delete(`batch/${id}`);
      const updatedBatches = batches.filter((batch) => batch.id !== id);
      setBatches(updatedBatches);
      toast.success('Batch deleted successfully');
    } catch (error) {
      console.error('Error deleting batch:', error);
      toast.error('Error deleting batch');
    }
  };

  // if (loading) {
  //   return <Loader />;
  // }
  const getStartingDate = (days) => {
    // Filter out undefined values
    const validDates = days.filter((day) => day.batchDate).map((day) => new Date(day.batchDate));

    // If there are no valid dates, return an empty string or a default value
    if (validDates.length === 0) {
      return '';
    }

    // Find the minimum date
    const minDate = new Date(Math.min(...validDates));

    // Format the minimum date
    return formatDate(minDate.toISOString());
  };



  const formatDate = (dateString, format = 'dd - mm - yyyy') => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();

    const formattedDate = format
      .replace('dd', day < 10 ? `0${day}` : day)
      .replace('mm', month)
      .replace('yyyy', year);

    return formattedDate;
  };



  const handleChangeType = (event) => {
    const selectedType = event.target.value;
    setFilterType(selectedType);
    setPage(0); // Reset pagination when changing the filter
    // fetchData(search, selectedType); // Pass search and the new type filter
  };

  const handleDownloadExcel = () => {
    // Prepare the table data for Excel
    const data = batches.map((batch) => ({
      'Course Name': batch.batchcode,
      Trainer: batch.trainers.map((trainer) => trainer.replace(/\(\d+\)/, '')).join(', '),
      // Manages: 'Manage',
    }));

    // Add the header row
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Batches');

    // Create Excel file and trigger download
    XLSX.writeFile(workbook, 'Batch_Details.xlsx');
  };


  return (
    <div>
      <Box
        sx={{
          position: 'fixed', // Keeps it in place
          top: '100px', // Fixed distance from the bottom
          left: '20px', // Fixed distance from the right
          zIndex: 1000 // Ensures it's above other content
        }}
      >

      </Box>
      <div className="container" style={{ maxWidth: '1400px' }}>


        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          {/* <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', marginTop: '5px' }}>
          <div style={{ position: 'relative', flex: '1' }}>
            <input
              type="text"
              placeholder="Search by code"
              value={search}
              onChange={handleSearchChange}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleSearchClick();
                }
              }}
              style={{
                padding: '8px 12px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                fontSize: '16px',
                width: '100%',
              }}
            />
            {search && (
              <span
                onClick={handleResetClick}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-x"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.354 8l3.823-3.823a.5.5 0 0 0-.708-.708L9.646 7.293 5.823 3.47a.5.5 0 0 0-.708.708L8.293 8l-3.823 3.823a.5.5 0 1 0 .708.708L9.646 8.707l3.823 3.823a.5.5 0 0 0 .708-.708L10.354 8z"
                  />
                </svg>
              </span>
            )}
          </div>
          <button
            className='btn btn-primary'
            onClick={handleSearchClick}
            style={{ marginLeft: '10px', padding: '8px 12px', fontSize: '16px' }}
          >
            Search
          </button>

          <select
            id="type"
            name="type"
            style={{ width: '20%', height: '44px', borderRadius: '6px', border: '1px solid #ced4da', marginLeft: '5px' }}
            value={filterType}
            onChange={handleChangeType}
            required
          >
            <option value="">Filterby Type</option>
            <option value="diploma">Diploma</option>
            <option value="advance_diploma">Advance Diploma</option>
          </select>

        </div> */}
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '10px',
              alignItems: 'center',
              marginBottom: '10px',
              marginTop: '5px',
            }}
          >
            <div style={{ position: 'relative', flex: '1 1 200px', minWidth: '200px' }}>
              <input
                type="text"
                placeholder="Search by Course Name"
                value={search}
                onChange={handleSearchChange}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleSearchClick();
                  }
                }}
                style={{
                  padding: '8px 12px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  fontSize: '16px',
                  width: '100%',
                }}
              />
              {search && (
                <span
                  onClick={handleResetClick}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-x"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.354 8l3.823-3.823a.5.5 0 0 0-.708-.708L9.646 7.293 5.823 3.47a.5.5 0 0 0-.708.708L8.293 8l-3.823 3.823a.5.5 0 1 0 .708.708L9.646 8.707l3.823 3.823a.5.5 0 0 0 .708-.708L10.354 8z"
                    />
                  </svg>
                </span>
              )}
            </div>

            <button
              className="btn btn-primary"
              onClick={handleSearchClick}
              style={{
                flex: '1 1 120px',
                minWidth: '120px',
                padding: '8px 12px',
                fontSize: '16px',
                backgroundColor: buttonBackgroundColor,
                color: 'white'
              }}
            >
              Search
            </button>

            <select
              id="type"
              name="type"
              value={filterType}
              onChange={handleChangeType}
              style={{
                flex: '1 1 180px',
                minWidth: '150px',
                height: '44px',
                borderRadius: '6px',
                border: '1px solid #ced4da',
              }}
            >
              <option value="">Filter by Type</option>
              <option value="diploma">Diploma</option>
              <option value="advance_diploma">Advance Diploma</option>
            </select>

            <Button
              variant="contained"
              color="primary"
              onClick={handleDownloadExcel}
              style={{
                flex: '1 1 150px',
                minWidth: '130px',
                padding: '8px 12px',
                fontSize: '14px',
                 backgroundColor: buttonBackgroundColor,
                color: 'white'
              }}
            >
              Download Excel
            </Button>
          </div>


          <TableContainer sx={{ maxHeight: 'none' }}>
            <div style={{ maxHeight: '600px', overflowY: 'auto' }} onScroll={handleScroll}>
              <Table aria-label="sticky table">
              <TableHead style={{ backgroundColor: 'black', position: 'sticky', top: 0, zIndex: 1 }}>
                  <TableRow>
                    <TableCell style={{ width: '40%'  , fontWeight: 'bold' }}>Course Name</TableCell>
                    {/* <TableCell style={{ width: '10%' }}>SSGWSQ</TableCell> */}
                    {/* <TableCell style={{ width: '15%' }}>Starting Date</TableCell> */}
                    <TableCell style={{ width: '20%'  , fontWeight: 'bold' }}>Trainer</TableCell>
                    <TableCell style={{ width: '20%'  , fontWeight: 'bold' }}>Manages</TableCell>
                    {/* <TableCell style={{ width: '20%' }}>Curriculum Manages</TableCell> */}
                    {/* <TableCell style={{ width: '20%' }}> Trainer Form</TableCell>
                  <TableCell style={{ width: '20%' }}>AR Templates</TableCell> */}
                    <TableCell style={{ width: '20%'  , fontWeight: 'bold' }}>Actions</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={6} style={{ textAlign: 'center' }}>
                        <div className="spinner-border text-info" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : (

                    batches.map((batch) => (
                      <TableRow key={batch.id}>
                        <TableCell>
                          <Link to={`/intake-details/batch/${encodeURIComponent(encryptData(batch.id))}`} style={{ textDecoration: 'none' }}>
                            {batch.batchcode}
                          </Link>
                        </TableCell>
                        {/* <TableCell>
                        <a href="/Managebatches" style={{ textDecoration: 'none' }}>
                          {batch.ssgWSQ} ssgWSQ
                        </a>
                      </TableCell> */}
                        {/* <TableCell>{getStartingDate(batch.days)}</TableCell> */}
                        <TableCell>
                          {batch.trainers.map((trainer) => trainer.replace(/\(\d+\)/, '')).join(', ')}
                        </TableCell>
                        <TableCell>
                          <Link to={`/intake-details/batch/${encodeURIComponent(encryptData(batch.id))}`} style={{ textDecoration: 'none' }}>
                            Manage
                          </Link>
                        </TableCell>
                        {/* <TableCell>{batch.contents}<Link to={`/Managec/${batch.id}/${batch.intakeId}`} style={{ textDecoration: 'none' }}>
                        Material Manage
                      </Link></TableCell> */}


                        <TableCell style={{ width: '10%' }}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Link to={`/BatchEdit/${batch.id}`} style={{ textDecoration: 'none' }}>
                              <BsPencilFill />
                            </Link>
                            <DeleteRoundedIcon
                              className="text-danger"
                              style={{ color: 'red', marginLeft: 10 }}
                              onClick={() => handleDelete(batch.id)}
                            />
                          </div>
                        </TableCell>

                      </TableRow>
                    ))
                  )}
                </TableBody>

              </Table>
              {!hasMore && !loading && (
                <Typography align="center" my={2}>
                  No more data to load.
                </Typography>
              )}
            </div>
          </TableContainer>

          {/* <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={totalBatches}
          rowsPerPage={itemsPerPage}
          page={currentPage}
          onPageChange={(event, newPage) => setCurrentPage(newPage)}
          // labelDisplayedRows={({ from, to }) => `${from}-${to} Page No ${currentPage}`}
          onRowsPerPageChange={event => {
            setItemsPerPage(parseInt(event.target.value, 50));
            setCurrentPage(0);
          }}
        /> */}
        </Paper>
        <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />
      </div>
    </div>


  );
};

const New = () => {
  const [tabValue, setTabValue] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };


  const handleTabChange = (newValue) => {
    setTabValue(newValue);
  };



  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const usertype = localStorage.getItem("usertype")
  const isLaptop = useMediaQuery('(min-width:600px) and (max-width:1400px)'); console.log('isLaptop', isLaptop)


  return (
    <div>
      <div>
        {usertype === '3' || usertype === '4' ? (
          <Header />
        ) : usertype === '6' ? (
          <FinHeader />
        ) : (

          null
        )}


      </div>
      <br />
      <div className="d-flex justify-content-center "
        style={{ marginTop: isMobile ? '-30px' : isLaptop ? '-20px' : '-70px', }}>

        <Tabs
          value={tabValue}
          onChange={handleChange}
          aria-label="Batches-tabs"
          variant="fullWidth"
          className="d-md-flex justify-content-md-center"
          sx={{
            borderRadius: 10,
            display: 'flex',
            justifyContent: 'center',
            "& button": {
              display: 'flex',
              justifyContent: 'center',
            },
            "& button:hover": {
              backgroundColor: "#eee",
            },
            "& button:active": {
              backgroundColor: "#ddd",
            },
            "& button.Mui-selected": {
              backgroundColor: "#007bff",
              color: "#fff",
            },
            "& .MuiTabs-indicator": {
              display: 'none', // Remove the underline
            },
            // Adjust width for mobile view
            ...(isMobile && {
              flexDirection: 'column', // Stack tabs vertically
              "& button": {
                width: '100%', // Set tabs to full width on mobile
              },
            }),
          }}
        >
          <Tab
            label="Courses"
            sx={{
              minWidth: { xs: '50%', sm: '360px', md: '500px', lg: '650px' }
            }}
          />
          <Tab
            label="New Course"
            sx={{
              minWidth: { xs: '50%', sm: '360px', md: '500px', lg: '650px' }
            }}
          />
        </Tabs>
      </div>
      <div>
        {tabValue === 0 && <Batches />}
        {tabValue === 1 && <NewBatches onFormSubmit={() => handleTabChange(0)} />}



      </div>
    </div>
  );

};

export default New;
